<ng-container *ngrxLet="data$ as data">
  <ng-container
    *ngrxLet="{
      isHeadlinesTrashcanView: isHeadlinesTrashcanView$,
      isTodosTrashcanView: isTodosTrashcanView$,
      language: language$,
    } as trash">
    <!-- This toolbar is for all other tools except feedback and conversations -->
    @if (
      data.activeTool !== '1-on-1' &&
      !(data.activeTool === 'assessments') &&
      data.activeTool !== '' &&
      !(data.activeTool?.includes('rocks') || data.activeTool?.includes('milestones'))
    ) {
      @if (trash.isHeadlinesTrashcanView) {
        <div class="headlines-trash-header-container">
          <button
            type="button"
            class="back-to-headlines"
            (click)="backToHeadlines()"
            data-cy="headlines-trash_back-link">
            <terra-icon icon="arrow-left" size="16" />Back to {{ trash.language?.headline?.items }}
          </button>
          <ninety-top-toolbar [meetingStarted]="inMeeting" data-cy="main-header_top-toolbar"></ninety-top-toolbar>
        </div>
      } @else if (trash.isTodosTrashcanView) {
        <div class="todos-trash-header-container">
          <button type="button" class="back-to-todos" (click)="backToTodos()" data-cy="todos-trash_back-link">
            <terra-icon icon="arrow-left" size="16" />Back to {{ trash.language?.todo?.items }}
          </button>
          <ninety-top-toolbar [meetingStarted]="inMeeting" data-cy="main-header_top-toolbar"></ninety-top-toolbar>
        </div>
      } @else {
        <ninety-top-toolbar [meetingStarted]="inMeeting" data-cy="main-header_top-toolbar"></ninety-top-toolbar>
      }
    }
    <!-- This toolbar specifically addresses conversation mobile views -->
    @if (isMobile && isConversation && inFeedback) {
      <ninety-top-toolbar [meetingStarted]="inMeeting" data-cy="main-header_top-toolbar"></ninety-top-toolbar>
    }
    @if (data.toolTabGroup && !(data.toolTabGroup.tool === '1-on-1') && !data.showIssuesTrash) {
      <ninety-tabs-bar class="terrafied-tabs">
        <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="ninety-tabs">
          @for (tab of data.toolTabGroup.tabs; track tab.route) {
            <span>
              <ng-container *ngrxLet="tab.show$ || true as show">
                @if (show) {
                  <a
                    mat-tab-link
                    [active]="data.activeRoute === tab.route"
                    (click)="navigateTo(data.activeTool, tab.route)"
                    [attr.data-cy]="tab.dataCy ? tab.dataCy : null">
                    {{ tab.label }}
                  </a>
                }
              </ng-container>
            </span>
          }
          <!-- Fixes: https://stackoverflow.com/questions/75200183/angular-15-1-mat-tab-nav-bar-require-tabpanel -->
          <mat-tab-nav-panel #tabPanel style="display: none"></mat-tab-nav-panel>
        </nav>
      </ninety-tabs-bar>
    }
  </ng-container>
</ng-container>
<ninety-filters-toolbar [isMeeting]="inMeeting" [isFeedback]="inFeedback"></ninety-filters-toolbar>
